import React, { useContext } from "react"
import { makeStyles } from "@material-ui/styles"
import { Typography } from "@material-ui/core/"
import { FormattedMessage, injectIntl } from "react-intl"
import { Link } from "gatsby"
import CheckSign from "./check.svg"
import alertSign from "./alert.svg"
import pendingSign from "./pending.svg"
import { Button } from ".."
import { CartContext } from ".."

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(10, 5, 0, 5),
  },
  checkSign: {
    height: theme.spacing(7),
    marginBottom: theme.spacing(2),
  },
  transaction: {
    textAlign: "center",
  },
  transRejected: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  reference: {
    textAlign: "center",
    margin: theme.spacing(4, 0, 3.525, 0),
  },
  referenceNum: {
    color: theme.palette.green.main,
  },
  content: {
    textAlign: "center",
    maxWidth: theme.spacing(73),
  },
  link: {
    color: theme.palette.green.main,
  },
  buttonLink: {
    textDecoration: "none",
    marginTop: theme.spacing(10),
  },
}))

const PaymentConfirComponent = props => {
  const { locale: localLocale } = props.intl
  let { removeAllFromCart } = useContext(CartContext)
  // Clear the cart contents on Moltin and from the site cache.
  removeAllFromCart()
  const classes = useStyles()
  return (
    <div className={classes.root}>
      {props.responseCode === "1" ? (
        <div className={classes.body}>
          <img className={classes.checkSign} src={CheckSign} alt="" />
          <Typography className={classes.transaction} variant={"h4"}>
            <FormattedMessage id="yourTransaction" />
          </Typography>
          <Typography className={classes.reference} variant={"h4"}>
            <FormattedMessage id="paymentReference" />
            <span className={classes.referenceNum}>{props.referenceNum}</span>
          </Typography>
          <Typography className={classes.content} variant={"h7"}>
            <FormattedMessage id="followUpRef" />
          </Typography>
        </div>
      ) : props.responseCode === "7" ? (
        <div className={classes.body}>
          <img className={classes.checkSign} src={pendingSign} alt="" />
          <Typography className={classes.transaction} variant={"h4"}>
            <FormattedMessage id="yourTransactionPending" />
          </Typography>
          <Typography className={classes.reference} variant={"h4"}>
            <FormattedMessage id="paymentReference" />
            <span className={classes.referenceNum}>{props.referenceNum}</span>
          </Typography>
          <Typography className={classes.content} variant={"subtitle1"}>
            <FormattedMessage id="PendingPayment" />
          </Typography>
        </div>
      ) : (
        <div className={classes.body}>
          <img className={classes.checkSign} src={alertSign} alt="" />
          <Typography className={classes.transRejected} variant={"h4"}>
            <FormattedMessage id="yourTransRejected" />
          </Typography>
          <Typography className={classes.content} variant={"subtitle1"}>
            <FormattedMessage id="rejectedPayment" />
          </Typography>
        </div>
      )}
      <Link className={classes.buttonLink} to={`/${localLocale}`}>
        <Button color="green">
          <FormattedMessage id="continueShopping" />
        </Button>
      </Link>
    </div>
  )
}

export default injectIntl(PaymentConfirComponent)
